import { useContext, useState, useEffect } from 'react'
import {
  ActivityLogContext,
  closeConfirmationModalAction,
  closeProgramDialogAction,
  openConfirmationModalAction,
  openProgramDialogAction,
  openProgramDoneModalAction,
  updateTotalWorkoutTimeAction
} from 'activity/ducks/index'
import useApi from 'common/hooks/useApi'
import DailyCache from 'common/utils/DailyCache'

export default function useProgramDialog() {
  const { state, dispatch } = useContext(ActivityLogContext)
  const [checked, setChecked] = useState(false)

  const exercises = state.programDialog?.data?.exercises

  const openProgramDialog = () => dispatch(openProgramDialogAction())
  const closeProgramDialog = () => dispatch(closeProgramDialogAction())

  const cachedSessionActivities = new DailyCache('sessionActivities')

  const [, addDay] = useApi(
    {
      method: 'POST',
      url: 'metrics/program_plan/add_day/'
    },
    { manual: true }
  )

  const openConfirmationModal = () => {
    dispatch(updateTotalWorkoutTimeAction(0))
    dispatch(openConfirmationModalAction('PROGRAM_DIALOG'))
  }
  const closeConfirmationModal = () => {
    dispatch(closeConfirmationModalAction('PROGRAM_DIALOG'))
  }
  const openProgramDoneModal = () => {
    dispatch(openProgramDoneModalAction())
  }

  useEffect(() => {
    const cacheArray = Object.keys(cachedSessionActivities.cache)
    let cachedDays = []
    if (cacheArray){
      cachedDays = cacheArray.filter(item => item.includes('Day'))
      cachedDays = cachedDays.map(item => Number(item.replace('Day-', '')))
      if (exercises?.length > 0){
        if (cachedDays.includes(exercises[0]?.dayId)){
          setChecked(true)
        } else {
          setChecked(false)
        }
      }
    }
  }, [exercises, cachedSessionActivities.cache])

  const logAllWorkoutsForDateSelected = async () => {
    if (exercises) {
      try {
        await addDay({
          data: {
            id: exercises[0].dayId,
            program_info: exercises[0]?.programInfo,
            cachedSessionActivities,
          }
        }).then((response) => {
          if (response?.status === 200) {
            exercises.forEach((exercise) => {
              if (exercise.dayId === exercises[0].dayId) {
                const exerciseNew = {...exercise, isDone: true}
                cachedSessionActivities.set(exerciseNew.id, exerciseNew)
                cachedSessionActivities.set(`Day-${exercises[0].dayId}`, exercises[0].dayId)
              }
            })
          }
        })
        const cacheArray = Object.keys(cachedSessionActivities.cache)
        if (cacheArray){
          const cachedRPE = cacheArray.filter(item => item.includes('RPE'))
          if (cachedRPE.length === 0) {
            openProgramDoneModal()
          }
        }
      } catch (e) {
        console.error('Error adding day', e)
      } finally {
        setChecked(true)
        closeConfirmationModal()
      }
    }
  }

  return {
    closeProgramDialog,
    openProgramDialog,
    state,
    dispatch,
    checked,
    setChecked,
    logAllWorkoutsForDateSelected,
    openConfirmationModal,
    closeConfirmationModal
  }
}
